import {AbstractPricingItemSummaryMapper} from "../abstract-pricing-item-summary.mapper";
import {PricingItem} from "../../../../../domain/in/quote/pricing-item/pricing-item";
import {PricingItemSummary} from "../../../../../domain/out/pricing-item-summary";
import {EnumPricingItemType} from "../../../../../domain/in/quote/pricing-item/pricing-item-type";
import {ConsumablePricingItem} from "../../../../../domain/in/quote/pricing-item/consumable-pricing-item";
import {DevicePricingItem} from "../../../../../domain/in/quote/pricing-item/device-pricing-item";
import {PackPricingItem} from "../../../../../domain/in/quote/pricing-item/pack-pricing-item";
import {MappingContext} from "../mapping-context";

export abstract class AbstractCaIcsHbeStandardMapper extends AbstractPricingItemSummaryMapper {

    protected async doMap(pricingItem: PricingItem, ctx: MappingContext): Promise<PricingItemSummary> {
        let pricingItemSummary = new PricingItemSummary();
        pricingItemSummary.codeElis = await this.getCodeElis(pricingItem, ctx);
        pricingItemSummary.label = this.getLabel(pricingItem);
        pricingItemSummary.quantity = this.getQuantity(pricingItem);
        pricingItemSummary.appliedPrice = this.getAppliedPrice(pricingItem, ctx);
        pricingItemSummary.totalAppliedPrice = ctx.formatAmount(pricingItem.totalAppliedPrice);
        pricingItemSummary.frequency = await ctx.getFrequency(pricingItem);
        pricingItemSummary.consoCodeElis = await this.getConsoCodeElis(pricingItem, ctx);
        pricingItemSummary.consoLabel = this.getConsoLabel(pricingItem);
        pricingItemSummary.consoQuantity = this.getConsoQuantity(pricingItem);
        pricingItemSummary.consoAppliedPrice = this.getConsoAppliedPrice(pricingItem, ctx);
        pricingItemSummary.extraPrice = this.getExtraPrice(pricingItem, ctx);
        return pricingItemSummary;
    }

    private getLabel(pricingItem: PricingItem) {
        if (pricingItem.pricingItemType == EnumPricingItemType.DEVICE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.PACK) {
            return (pricingItem as DevicePricingItem).device.label;
        }
        return '';
    }

    private getAppliedPrice(pricingItem: PricingItem, ctx: MappingContext) {
        if (pricingItem.pricingItemType == EnumPricingItemType.DEVICE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.PACK) {
            return ctx.formatAmount((pricingItem as DevicePricingItem).device.appliedPrice);
        }
        return '';
    }

    private getQuantity(pricingItem: PricingItem) {
        if (pricingItem.pricingItemType == EnumPricingItemType.DEVICE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.PACK) {
            return pricingItem.userInputs.quantity;
        }
        return '';
    }

    private async getCodeElis(pricingItem: PricingItem, ctx: MappingContext) {
        if (pricingItem.pricingItemType == EnumPricingItemType.DEVICE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.PACK) {
            return ctx.resolveCodeElis((pricingItem as DevicePricingItem).device.codeElis);
        }
        return '';
    }

    private getExtraPrice(pricingItem: PricingItem, ctx: MappingContext) {
        if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE) {
            return (pricingItem as ConsumablePricingItem).consumableExtraPrice
                ? ctx.formatAmount((pricingItem as ConsumablePricingItem).consumableExtraPrice)
                : '';
        } else {
            return '';
        }
    }

    private getConsoAppliedPrice(pricingItem: PricingItem, ctx: MappingContext) {
        if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE) {
            return (pricingItem as ConsumablePricingItem).consumable.appliedPrice
                ? ctx.formatAmount((pricingItem as ConsumablePricingItem).consumable.appliedPrice)
                : '';
        } else {
            return '';
        }
    }

    private getConsoQuantity(pricingItem: PricingItem) {
        if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE) {
            return pricingItem.userInputs.consumableQuantity;
        } else {
            return '';
        }
    }

    private getConsoLabel(pricingItem: PricingItem) {
        if (pricingItem.pricingItemType == EnumPricingItemType.PACK) {
            return (pricingItem as PackPricingItem).device.articleDetails['pack']["label"];
        } else if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE) {
            return (pricingItem as ConsumablePricingItem).consumable.label;
        } else {
            return '';
        }
    }

    private async getConsoCodeElis(pricingItem: PricingItem, ctx: MappingContext): Promise<string> {
        if (pricingItem.pricingItemType == EnumPricingItemType.PACK) {
            return ctx.resolveCodeElis((pricingItem as PackPricingItem).device.articleDetails['pack']["code"]);
        } else if (pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE ||
            pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE) {
            return ctx.resolveCodeElis((pricingItem as ConsumablePricingItem).consumable.codeElis);
        } else {
            return '';
        }
    }

}